import React, { useState, useCallback } from "react";
import {
  signoutUserFailure,
  signoutUserStart,
  signoutUserSuccess,
} from "../../redux/user/userSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const SignOut = ({ isLoggingOut: parentIsLoggingOut, onLogoutStateChange }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [localIsLoggingOut, setLocalIsLoggingOut] = useState(false);
  
  const isLoggingOut = parentIsLoggingOut || localIsLoggingOut;

  const handleSignout = useCallback(async () => {
    if (isLoggingOut) return; // Prevent multiple logout attempts
    
    try {
      setLocalIsLoggingOut(true);
      onLogoutStateChange?.(true);
      
      dispatch(signoutUserStart());
      
      // Add timeout to prevent hanging requests
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const res = await fetch("/api/user/signout/", {
        signal: controller.signal,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      clearTimeout(timeoutId);
      
      const data = await res.json();
      if (data.success === false) {
        dispatch(signoutUserFailure(data.message));
        return;
      }

      dispatch(signoutUserSuccess(data));
      
      // Navigate immediately after successful logout
      navigate("/sign-in");
      
    } catch (error) {
      console.error("Logout error:", error);
      if (error.name === 'AbortError') {
        dispatch(signoutUserFailure("Logout request timed out"));
      } else {
        dispatch(signoutUserFailure(error.message));
      }
    } finally {
      setLocalIsLoggingOut(false);
      onLogoutStateChange?.(false);
    }
  }, [dispatch, navigate, isLoggingOut, onLogoutStateChange]);

  return (
    <button 
      onClick={handleSignout} 
      className="logout-button"
      disabled={isLoggingOut}
    >
      {isLoggingOut ? (
        <>
          <span className="logout-spinner"></span>
          Logging out...
        </>
      ) : (
        "Log Out"
      )}
    </button>
  );
};

export default SignOut;
